import { render, staticRenderFns } from "./Stocking.vue?vue&type=template&id=424e1ebc&scoped=true"
import script from "./Stocking.vue?vue&type=script&lang=js"
export * from "./Stocking.vue?vue&type=script&lang=js"
import style0 from "./Stocking.vue?vue&type=style&index=0&id=424e1ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e1ebc",
  null
  
)

export default component.exports